import { useState } from "react";
import { EyeIcon, Goal, Lightbulb } from "lucide-react";

const StrategySection = () => {
    const [activeTab, setActiveTab] = useState("home");

    const getTranslateValue = () => {
        switch (activeTab) {
            case "home":
                return { left: "0%", transform: "translateX(0%)" };
            case "gallery":
                return { left: "50%", transform: "translateX(-50%)" };
            case "settings":
                return { left: "100%", transform: "translateX(-100%)" };
            default:
                return { left: "0%", transform: "translateX(0%)" };
        }
    };

    const translateStyles = getTranslateValue();

    const renderContent = () => {
        switch (activeTab) {
            case "home":
                return (
                    <div>
                        <h1 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-secondary sm:mb-4 mb-3">Mission Statement:</h1>
                        <p className="md:text-lg sm:text-base text-sm max-w-7xl">To catalyze the transformation of individuals and organizations into beacons of excellence, fostering a culture of continuous learning and innovation that empowers them to achieve extraordinary outcomes.
                        </p>
                    </div>
                );
            case "gallery":
                return (
                    <div>
                        <h1 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-secondary sm:mb-4 mb-3">Vision Statement:</h1>
                        <p className="md:text-lg sm:text-base text-sm max-w-7xl">To be the global pioneer in human capital development, revolutionizing the training and consulting landscape by delivering unparalleled experiences that ignite potential, elevate performance, and shape a brighter future.

                        </p>
                    </div>
                );
            case "settings":
                return (
                    <div>
                        <h1 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-secondary sm:mb-4 mb-3">Core Values:</h1>
                        <p className="md:text-lg sm:text-base text-sm max-w-7xl">Unwavering Commitment to Excellence: We are relentless in our pursuit of perfection, setting the highest standards for ourselves and our clients.
                            <br/>
                            <br/>
                            Innovation and Adaptability: We embrace change as an opportunity for growth, continuously exploring new approaches and technologies to stay ahead of the curve.
                            <br/>
                            <br/>
                            Client-Centric Partnership: We view our clients as partners, working collaboratively to understand their unique needs and deliver tailored solutions that exceed their expectations.
                            <br/>
                            <br/>
                            Ethical Integrity: We uphold the highest ethical standards in all our interactions, building trust and credibility with our clients and stakeholders.
                            <br/>
                            <br/>
                            Empowerment and Development: We invest in the growth of our team members, fostering a culture of continuous learning and empowering them to reach their full potential.
                            <br/>
                            <br/>
                            Social Responsibility: We are committed to making a positive impact on society through our work, contributing to the development of individuals and communities.
                        </p>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <div className="sm:min-h-20 min-h-16 bg-white  border-b border-t shadow w-full md:py-5 py-3">
                <div className="max-w-[1108px] mx-auto">
                <div className="flex items-center justify-between  mx-4 relative h-full ">
                    <div
                        className="absolute md:-top-5 -top-3 md:h-1.5 h-1 sm:w-[95px] w-14 rounded-full bg-secondary transition-all duration-300 ease-in-out"
                        style={{
                            left: translateStyles.left,
                            transform: translateStyles.transform,
                        }}
                    ></div>
                    <div
                        className={`cursor-pointer flex flex-col items-center relative sm:min-w-[95px] min-w-14 h-full justify-center transition-all duration-300 ease-in-out ${activeTab === "home" ? "text-secondary" : "text-primary"
                            }`}
                        onClick={() => setActiveTab("home")}
                    >
                        <Goal className="lg:size-10 md:size-8 sm:size-7 size-5" />
                        <h1 className="font-bold lg:text-2xl md:text-lg sm:text-base text-sm mt-1 sm:mt-2">Mission</h1>
                    </div>
                    <div
                        className={`cursor-pointer flex flex-col items-center relative sm:min-w-[95px] min-w-14 h-full justify-center transition-all duration-300 ease-in-out ${activeTab === "gallery" ? "text-secondary" : "text-primary"
                            }`}
                        onClick={() => setActiveTab("gallery")}
                    >
                        <EyeIcon className="lg:size-10 md:size-8 sm:size-7 size-5" />
                        <h1 className="font-bold lg:text-2xl md:text-lg sm:text-base text-sm mt-1 sm:mt-2">Vision</h1>
                    </div>
                    <div
                        className={`cursor-pointer flex flex-col items-center relative sm:min-w-[95px] min-w-14 h-full justify-center transition-all duration-300 ease-in-out ${activeTab === "settings" ? "text-secondary" : "text-primary"
                            }`}
                        onClick={() => setActiveTab("settings")}
                    >
                        <Lightbulb className="lg:size-10 md:size-8 sm:size-7 size-5" />
                        <h1 className="font-bold lg:text-2xl md:text-lg sm:text-base text-sm mt-1 sm:mt-2">Core</h1>
                    </div>
                </div>

                </div>
            </div>

            {/* Content Section */}
            <div className="sm:mt-12 mt-8 container sm:mb-8 mb-4">
                {renderContent()}
            </div>
        </div>
    );
};

export default StrategySection;
